import React, {useState} from "react";
import {Checkbox, Col, DatePicker, Form, Input, Modal, Row} from "antd";
import dayjs from "dayjs";
import {
    PickupAuthorization
} from "../../../../../../models/accounts/customer-account/wholesale-account/wholesale.account.pickup-authorizations";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {
    accountPickupAuthorizationsService
} from "../../../../../../services/accounts/account.pickup-authorizations.service";

interface AgentDataPickupAuthorizationCreateModalProps {
    accountId: number,
    item: PickupAuthorization | null,
    onClose: () => void,
    onComplete: () => void,
}

export const AgentDataPickupAuthorizationCreateModal: React.FC<AgentDataPickupAuthorizationCreateModalProps> = ({item, accountId, onClose, onComplete}) => {
    const t = useTranslate();

    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);

    let defaultValues: any = {}
    if (item) {
        defaultValues = {...item}
        defaultValues.date = dayjs(item.date);
    }

    return (
        <Modal
            open
            loading={loading}
            title={item ? t("EDIT") : t("ADD")}
            okText={t("SAVE")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            centered
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name={"order_data"}
                initialValues={defaultValues}
                onFinish={() => form
                    .validateFields()
                    .then(async values => {
                        setLoading(true);
                        try {
                            if (item) {
                                await accountPickupAuthorizationsService.update(item.id, values)
                            } else {
                                await accountPickupAuthorizationsService.create(accountId, values)
                            }

                            onComplete();
                            onClose();
                        } catch (e) {

                        } finally {
                            setLoading(false);
                        }
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="number"
                            label={"Number"}
                        >
                            <Input disabled={loading} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="issuedBy"
                            label={"Issued By"}
                        >
                            <Input disabled={loading} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="authorizedPerson"
                            label={"Authorized person"}
                        >
                            <Input disabled={loading} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="date"
                            label={t("Date")}
                        >
                            <DatePicker disabled={loading} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
